import { l } from './imports'
import { IV } from './IV'
import { assert } from './assert-sidecar'

//https://www.npmjs.com/package/fast-random
// import { random } from 'fast-random'
const random = require('fast-random')

const seed = Date.now()
const r: { nextFloat: () => number; nextInt: () => number } = random(seed)

export function f(min: number, max: number) {
  return min + (max - min) * r.nextFloat()
}

export function i(min: number, max: number) {
  return min + (r.nextInt() % (max - min + 1))
}

export const b = (): boolean => {
  return chance(0.5)
}

export function chance(factor: number): boolean {
  return r.nextFloat() <= factor
}
export function sign() {
  return chance(0.5) ? 1 : -1
}
export function sample<T>(arr: T[]) {
  assert.t(arr.length > 0)
  let idx = i(0, arr.length - 1)
  return arr[idx]
}

export function vec(): IV {
  let x = f(-1, 1)
  let y = f(-1, 1)
  // let v = Vec2(x, y)
  // v.normalize()

  return { x, y }
}

export interface IChances {
  [key: string]: number
}
export interface IChancesBakedItem {
  min: number
  max: number
  key: string
  weight: number
}
export function bakeChances(
  chances: IChances,
  max: number = 100,
): IChancesBakedItem[] {
  let baked: IChancesBakedItem[] = []

  let total = 0
  l.forEach(chances, (c, cIdx) => {
    total += c
  })
  if (total > max) {
    max = total
  }

  let v = 0
  l.forEach(chances, (c, cIdx) => {
    let w = c / max
    let v2 = w + v
    baked.push({
      min: v,
      max: v2,
      key: cIdx,
      weight: w,
    })
    v = v2
  })

  return baked
}
export function randomChances(
  chances: IChancesBakedItem[],
  _default: string = '',
): string {
  let v = f(0, 1)
  for (let i = 0; i < chances.length; i++) {
    let c = chances[i]
    if (v >= c.min && v < c.max) {
      return c.key
    }
  }
  return _default
}
